"use strict";
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MstrCover = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const look_up_entity_1 = require("./look-up.entity");
let MstrCover = class MstrCover {
    constructor(name, description, coverTypeLid, inputType, inputLov, coversMeta) {
        this.name = name;
        this.description = description;
        this.coverTypeLid = coverTypeLid;
        this.inputType = inputType;
        this.inputLov = inputLov;
        this.coversMeta = coversMeta;
    }
};
exports.MstrCover = MstrCover;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], MstrCover.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "name", type: "varchar", length: 200, nullable: false }),
    tslib_1.__metadata("design:type", String)
], MstrCover.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "description", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], MstrCover.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_type", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], MstrCover.prototype, "coverTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "input_type", type: "varchar", length: 100, nullable: true }),
    tslib_1.__metadata("design:type", String)
], MstrCover.prototype, "inputType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "input_lov", type: "jsonb", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Record !== "undefined" && Record) === "function" ? _c : Object)
], MstrCover.prototype, "inputLov", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "covers_meta", type: "jsonb", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Record !== "undefined" && Record) === "function" ? _d : Object)
], MstrCover.prototype, "coversMeta", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], MstrCover.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        onUpdate: "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], MstrCover.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], MstrCover.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], MstrCover.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "cover_type", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_g = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _g : Object)
], MstrCover.prototype, "coverType", void 0);
exports.MstrCover = MstrCover = tslib_1.__decorate([
    (0, typeorm_1.Entity)("mstr_cover"),
    tslib_1.__metadata("design:paramtypes", [String, String, Number, String, typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object, typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object])
], MstrCover);
